// extracted by mini-css-extract-plugin
module.exports = {"scene":"HeroScene_scene__FLhxc","blob":"HeroScene_blob__bvfTY","bloom":"HeroScene_bloom__zHhYW","figure":"HeroScene_figure__2bjhs","hero-bob":"HeroScene_hero-bob___GM2j"};